export const UNKNOWN_REQUEST_REJECTION = 'UNKNOWN_REQUEST_REJECTION';
